// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".blue-filter{filter:brightness(0) saturate(100%) invert(13%) sepia(71%) saturate(3668%) hue-rotate(215deg) brightness(99%) contrast(105%)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
